<template>
	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section>
			<nav class="side-nav">
			</nav>

			<div class="container-fiuld clearfix">
				<div class="title-box b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">출결관리</div>
					<!--
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
					-->
				</div>
				<table class="table2 table-condensed table-hover text-center">
					<thead>
						<tr>
							<th></th>
							<th></th>
							<th></th>
							<th>
								<a @click="pullLeft">
									<img src="images/next-icon.png" alt="" style="transform: rotateZ(180deg);">
								</a>
							</th>
							<th>{{ (startNo+0+1) &lt;= parseInt(lecture.eduDay) ? (startNo+0+1)+'회' : '' }}</th>
							<th>{{ (startNo+1+1) &lt;= parseInt(lecture.eduDay) ? (startNo+1+1)+'회' : '' }}</th>
							<th>{{ (startNo+2+1) &lt;= parseInt(lecture.eduDay) ? (startNo+2+1)+'회' : '' }}</th>
							<th>{{ (startNo+3+1) &lt;= parseInt(lecture.eduDay) ? (startNo+3+1)+'회' : '' }}</th>
							<th>
								<a @click="pullRight">
									<img src="images/next-icon.png" alt="">
								</a>
							</th>
						</tr>
						<tr class="margin">
							<th colspan="9"></th>
						</tr>
						<tr>
							<th width="80"></th>
							<th colspan="3"></th>
							<th>
								<div class="input-group full-width m-t-5" v-if="(startNo+0+1) &lt;= parseInt(lecture.eduDay)">
									<span class="input-group-addon v-mid clearfix">
										<div class="checkbox">
											<input id="atten-list-miss-all-0" type="radio" name="atten-list-all-0" value="결석" v-model="attenAll0">
											<label for="atten-list-miss-all-0" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input id="atten-list-check-all-0" type="radio" name="atten-list-all-0" value="출석" v-model="attenAll0">
											<label for="atten-list-check-all-0" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</th>
							<th>
								<div class="input-group full-width m-t-5" v-if="(startNo+1+1) &lt;= parseInt(lecture.eduDay)">
									<span class="input-group-addon v-mid clearfix">
										<div class="checkbox">
											<input id="atten-list-miss-all-1" type="radio" name="atten-list-all-1" value="결석" v-model="attenAll1">
											<label for="atten-list-miss-all-1" class="s-lineH f-14 red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input id="atten-list-check-all-1" type="radio" name="atten-list-all-1" value="출석" v-model="attenAll1">
											<label for="atten-list-check-all-1" class="s-lineH f-14 round-right">출석</label>
										</div>
									</span>
								</div>
							</th>
							<th>
								<div class="input-group full-width m-t-5" v-if="(startNo+2+1) &lt;= parseInt(lecture.eduDay)">
									<span class="input-group-addon v-mid clearfix">
										<div class="checkbox">
											<input id="atten-list-miss-all-2" type="radio" name="atten-list-all-2" value="결석" v-model="attenAll2">
											<label for="atten-list-miss-all-2" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input id="atten-list-check-all-2" type="radio" name="atten-list-all-2" value="출석" v-model="attenAll2">
											<label for="atten-list-check-all-2" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</th>
							<th>
								<div class="input-group full-width m-t-5" v-if="(startNo+3+1) &lt;= parseInt(lecture.eduDay)">
									<span class="input-group-addon v-mid clearfix">
										<div class="checkbox">
											<input id="atten-list-miss-all-3" type="radio" name="atten-list-all-3" value="결석" v-model="attenAll3">
											<label for="atten-list-miss-all-3" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input id="atten-list-check-all-3" type="radio" name="atten-list-all-3" value="출석" v-model="attenAll3">
											<label for="atten-list-check-all-3" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</th>
							<th></th>
						</tr>
					</thead>
					<tbody v-for="(item,idx) in list" :item="item" :index="idx" :key="'atten-list-for-'+lecture.lecId+'-'+item.mberId+'-'+item.applId+'-'+idx">
						<tr class="margin">
							<td colspan="9"></td>
						</tr>
						<tr>
							<td><!--<button class="btn btn-blue round pull-left">편집</button>--></td>
							<td>{{item.mberName}}</td>
							<td>{{item.attenList.filter(e=>e.state=='출석').length}} / {{item.attenList.length}}</td>
							<td></td>
							<td>
								<div class="input-group full-width m-t-5" v-if="(startNo+0) &lt;= item.attenList.length">
									<span class="input-group-addon v-mid clearfix" v-if="item.attenList[startNo+0]">
										<div class="checkbox">
											<input :id="'atten-miss-for-'+item.mberName+'-'+(startNo+0)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+0)" value="결석" v-model="item.attenList[startNo+0].state" @change="changeAttenState(item, startNo+0)">
											<label :for="'atten-miss-for-'+item.mberName+'-'+(startNo+0)" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input :id="'atten-check-for-'+item.mberName+'-'+(startNo+0)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+0)" value="출석" v-model="item.attenList[startNo+0].state" @change="changeAttenState(item, startNo+0)">
											<label :for="'atten-check-for-'+item.mberName+'-'+(startNo+0)" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</td>
							<td>
								<div class="input-group full-width m-t-5" v-if="(startNo+1) &lt;= item.attenList.length">
									<span class="input-group-addon v-mid clearfix" v-if="item.attenList[startNo+1]">
										<div class="checkbox">
											<input :id="'atten-miss-for-'+item.mberName+'-'+(startNo+1)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+1)" value="결석" v-model="item.attenList[startNo+1].state" @change="changeAttenState(item, startNo+1)">
											<label :for="'atten-miss-for-'+item.mberName+'-'+(startNo+1)" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input :id="'atten-check-for-'+item.mberName+'-'+(startNo+1)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+1)" value="출석" v-model="item.attenList[startNo+1].state" @change="changeAttenState(item, startNo+1)">
											<label :for="'atten-check-for-'+item.mberName+'-'+(startNo+1)" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</td>
							<td>
								<div class="input-group full-width m-t-5" v-if="(startNo+2) &lt;= item.attenList.length">
									<span class="input-group-addon v-mid clearfix" v-if="item.attenList[startNo+2]">
										<div class="checkbox">
											<input :id="'atten-miss-for-'+item.mberName+'-'+(startNo+2)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+2)" value="결석" v-model="item.attenList[startNo+2].state" @change="changeAttenState(item, startNo+2)">
											<label :for="'atten-miss-for-'+item.mberName+'-'+(startNo+2)" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input :id="'atten-check-for-'+item.mberName+'-'+(startNo+2)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+2)" value="출석" v-model="item.attenList[startNo+2].state" @change="changeAttenState(item, startNo+2)">
											<label :for="'atten-check-for-'+item.mberName+'-'+(startNo+2)" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</td>
							<td>
								<div class="input-group full-width m-t-5" v-if="(startNo+3) &lt;= item.attenList.length">
									<span class="input-group-addon v-mid clearfix" v-if="item.attenList[startNo+3]">
										<div class="checkbox">
											<input :id="'atten-miss-for-'+item.mberName+'-'+(startNo+3)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+3)" value="결석" v-model="item.attenList[startNo+3].state" @change="changeAttenState(item, startNo+3)">
											<label :for="'atten-miss-for-'+item.mberName+'-'+(startNo+3)" class="s-lineH red round-left">결석</label>
										</div>
										<div class="checkbox">
											<input :id="'atten-check-for-'+item.mberName+'-'+(startNo+3)" type="radio" :name="'atten-for-'+item.mberName+'-'+(startNo+3)" value="출석" v-model="item.attenList[startNo+3].state" @change="changeAttenState(item, startNo+3)">
											<label :for="'atten-check-for-'+item.mberName+'-'+(startNo+3)" class="s-lineH round-right">출석</label>
										</div>
									</span>
								</div>
							</td>
							<td></td>
						</tr>
					</tbody>
				</table>
			</div>
		</section>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>

		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import fnGetLec from '../mixins/fnGetLec.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'

export default {
	name: "ViewClassroomAttendance",
	mixins: [fnAdjustHeight, fnGetLec],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
		ModalConfirm,
		ModalAlert
	},

	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
		if(this.lecture.classroomOpt.indexOf("출결")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='출결')), 1 );
		if(this.lecture.classroomOpt.indexOf("과제")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=="과제")), 1 );
		if(this.lecture.classroomOpt.indexOf("설문")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='설문')), 1 );
		if(this.lecture.classroomOpt.indexOf("시험")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='시험')), 1 );
		//if(this.lecture.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
		this.refresh();
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			lecture: {},
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:true},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:false},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			buttons : [],
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default()
			},
			curriculumId: this.$route.params.curriculumId,
			list: [],
			startNo: 0,
			attenAll0: "",
			attenAll1: "",
			attenAll2: "",
			attenAll3: "",
		}
	},

	watch: {
		attenAll0: function(state) {
			// eslint-disable-next-line
			console.log( "this.list 내의 모든 수강생에 대하여 "+(this.startNo+0+1)+"회차 수업을 모두 "+state+" 처리해야 한다.", this.list);
			axios.patch(server.addr()+server.api.ATTEN, this.list.map(e=>{
				// eslint-disable-next-line
				console.log(e.attenList[this.startNo+0].attenId, e.attenList[this.startNo+0].mberId, e.attenList[this.startNo+0].attenName);

				return {
				attenId:e.attenList[this.startNo+0].attenId,
				state
			}})).then(()=>this.refresh());
		},
		attenAll1: function(state) {
			// eslint-disable-next-line
			console.log( "this.list 내의 모든 수강생에 대하여 "+(this.startNo+1+1)+"회차 수업을 모두 "+state+" 처리해야 한다.", this.list);
			axios.patch(server.addr()+server.api.ATTEN, this.list.map(e=>{return {
				attenId:e.attenList[this.startNo+1].attenId,
				state
			}})).then(()=>this.refresh());
		},
		attenAll2: function(state) {
			// eslint-disable-next-line
			console.log( "this.list 내의 모든 수강생에 대하여 "+(this.startNo+2+1)+"회차 수업을 모두 "+state+" 처리해야 한다.", this.list);
			axios.patch(server.addr()+server.api.ATTEN, this.list.map(e=>{return {
				attenId:e.attenList[this.startNo+2].attenId,
				state
			}})).then(()=>this.refresh());
		},
		attenAll3: function(state) {
			// eslint-disable-next-line
			console.log( "this.list 내의 모든 수강생에 대하여 "+(this.startNo+3+1)+"회차 수업을 모두 "+state+" 처리해야 한다.", this.list);
			axios.patch(server.addr()+server.api.ATTEN, this.list.map(e=>{return {
				attenId:e.attenList[this.startNo+3].attenId,
				state
			}})).then(()=>this.refresh());
		},
	},

	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {
		// 수업일정을 불러온다.
		refresh: function() {
			// this.lecture.classroomOpt에 "출결" 항목이 있어야하고, this.lecture.eduPeriodType이 "일정 선택"이고, this.lecture.eduDay가 정해져있는 경우에만 진행할 수 있음
			if(this.lecture.classroomOpt.indexOf("출결")!=-1 && this.lecture.eduDay) {
				// this.lecture에 대한 수강생 목록을 불러온다.
				axios.post(server.addr()+server.api.APPL, {lecId:this.lecture.lecId, applStatus:"승인", certStatus:"미수료"}).then(response => {
					// 각 수강생을 순회하면서 출결정보를 만든다.
					this.list = response.data.list.map(e => {
						if(!e.attenList || e.attenList.length==0) {
							e.attenList = [];
							for(let i=0; i<parseInt(this.lecture.eduDay); i+=1) {
								let obj = {mberId:e.mberId, applId:e.applId, lecId:e.lecId, applEduDateId:e.applEduDateList[i].applEduDateId, attenCount:i+1, attenMaxCount:this.lecture.eduDay, attenName:moment(e.applEduDateList[i].eduStartDate).format("YYYY-MM-DD"), state:''};
								axios.put(server.addr()+server.api.ATTEN, [obj]).then(response => {
									e.attenList.push(response.data.list[0]);
								})
							}
						}
						return e;
					})
					// 화면에 표시할 수업일수를 1회~4회로 설정
					this.startNo = 0;
				});
			}
		},
		pullLeft: function() {
			if(this.startNo > 0) this.startNo -= 1;
		},
		pullRight: function() {
			if(this.startNo+1 < parseInt(this.lecture.eduDay)) this.startNo += 1;
		},
		changeAttenState: function(item, idx) {
			// eslint-disable-next-line
			console.log(item.mberName+" 회원의 "+idx+"번째 수업을 "+item.attenList[idx].state+"로 변경해야 함");
			axios.patch(server.addr()+server.api.ATTEN, [{
				attenId:item.attenList[idx].attenId,
				state:item.attenList[idx].state
			}]).then(()=>{});
		}
	},

	filters: {
		parseRegDate(date){
			return moment(date).format('YYYY-MM-DD')
		},
	}
}
</script>
